function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.500867 11.5196L11.5199 0.50056C11.7968 0.223748 12.245 0.223914 12.5217 0.50056L18.5321 6.51097C18.8087 6.78761 18.8089 7.23589 18.5321 7.5127L7.51301 18.5318C7.2362 18.8086 6.78792 18.8084 6.51128 18.5318L0.500867 12.5214C0.224222 12.2447 0.224055 11.7965 0.500867 11.5196ZM5.58033 15.5974C6.46386 15.0775 7.56076 15.0775 8.44395 15.5974L15.5977 8.44365C15.0779 7.56028 15.0779 6.46339 15.598 5.58002L13.4528 3.43481C12.5693 3.95471 11.4725 3.95454 10.5892 3.43481L3.43528 10.5887C3.95518 11.4722 3.95502 12.569 3.43528 13.4523L5.58033 15.5974ZM11.0191 11.0188C11.8477 10.1902 11.8477 8.84217 11.0191 8.01357C10.1905 7.18497 8.84248 7.18497 8.01388 8.01357C7.18528 8.84217 7.18528 10.1902 8.01388 11.0188C8.84248 11.8474 10.1905 11.8474 11.0191 11.0188Z"
});

var SvgDollar = function SvgDollar(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#939BA1"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/dollar.c104d033.svg";
export { SvgDollar as ReactComponent };